import { Globe } from 'lucide-react'

import type { SubjectDetailsResponse } from '@/api/types/Subject'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import ExternalLinkCard from '@/elements/ExternalLinkCard'
import useBreakpoints from '@/hooks/useBreakpoints'
import { flattenSocialChannels } from '@/utils/socialChannels'
import Pagination from '@/components/Pagination'
import usePagination from '@/hooks/usePagination'

function OfficialChannels({ channels }: {
  channels: SubjectDetailsResponse['social'] | null
}) {
  const { isMobile } = useBreakpoints()
  const { page, setPage, limit } = usePagination(5)

  if (!channels) return null

  const matchedChannels = channels ? flattenSocialChannels(channels) : []
  const paginatedChannels = matchedChannels.slice((page - 1) * limit, page * limit)
  const totalPages = Math.ceil(matchedChannels.length / limit)

  return (
    <Flex wfull p={!isMobile ? 4 : 3} gap={4} align='center' className='card'>
      <Flex wfull>
        <Text variant='h3'>Official Channels</Text>
      </Flex>
      <Flex wfull gap={2}>
        {matchedChannels?.length === 0 ? (
          <Flex wfull align='center' py={4}>
            <Text color='black-light-60'>No official channels available.</Text>
          </Flex>
        ) : (paginatedChannels.map((channel, index) => (
          <ExternalLinkCard
            key={`${channel.name}-${index}`}
            to={channel.url}
            Icon={channel.icon || Globe}
            imageSrc={channel.avatarUrl || undefined}
          >
            <Flex>
              <Text variant='footnote' color='black-light-40'>{channel.name}</Text>
              <Text>{channel.handle || channel.url}</Text>
            </Flex>
          </ExternalLinkCard>
        )))}
      </Flex>
      <Pagination
        variant={isMobile ? 'compact' : 'default'}
        onPageChange={setPage}
        totalPages={totalPages}
        page={page}
      />
    </Flex>
  )
}

export default OfficialChannels
